import MagazineLayout from "@/components/MagazineLayout";
import Seo from "@/components/Seo";

const SECTIONS = [
  ["What cookies are", "Cookies are small text files stored on your device. Most websites drown you in them; we keep it to the bare minimum a working magazine needs."],
  ["Strictly necessary", "We store a small token in your browser when members or the editorial desk sign in, so you stay signed in as you move around. We also remember your cookie choice itself. These are essential — the site cannot function without them and UK law does not require consent for them."],
  ["What we do NOT use", "No advertising cookies. No third-party ad networks. No cross-site tracking. No social media pixels. If we ever introduce analytics, we will choose a privacy-first tool and update this page and the consent notice first."],
  ["Payments", "If you purchase a membership, Stripe (our payment processor) may set its own cookies on Stripe's checkout pages to prevent fraud. Stripe's cookie policy governs those."],
  ["Managing cookies", "You can clear or block cookies in your browser settings at any time. Blocking the essential ones will sign you out of the Members' Portal and Studio."],
  ["Changes", "If our use of cookies ever changes, this page will say so plainly, and the corner notice will reappear so you can choose again."],
  ["Contact", "Questions about cookies or your data: hello@smemagazine.co.uk."],
];

export default function Cookies() {
  return (
    <MagazineLayout>
      <Seo title="Cookie Policy — S/ME" description="The few cookies S/ME uses, and the many it doesn't." />
      <div className="pt-[68px] bg-cream min-h-screen" data-testid="cookies-page">
        <header className="px-5 sm:px-8 pt-16 sm:pt-24 pb-10 max-w-[860px] mx-auto">
          <p className="overline text-gloss-silver mb-4">The small print</p>
          <h1 className="font-serif text-5xl sm:text-7xl tracking-tight leading-none">Cookie Policy</h1>
          <p className="font-sans text-lg text-ink/70 mt-5 max-w-xl">
            Short version: only what keeps the magazine working. No trackers, no ad networks.
          </p>
        </header>
        <section className="px-5 sm:px-8 pb-24 max-w-[860px] mx-auto">
          <div className="border-t border-ink/15">
            {SECTIONS.map(([h, body]) => (
              <div key={h} className="py-8 border-b border-ink/10 grid grid-cols-1 sm:grid-cols-[220px_1fr] gap-3">
                <h2 className="font-serif text-xl tracking-tight">{h}</h2>
                <p className="font-sans text-[15px] text-ink/75 leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
          <p className="font-mono text-[11px] text-ink/40 mt-8">Last updated: June 2026 · S/ME — The UK's Online SME Magazine</p>
        </section>
      </div>
    </MagazineLayout>
  );
}
